import type { MetaInfo } from 'vue-meta';

export const getMetaInfo = (page: any, isNoIndex = false): MetaInfo => {
  if (!page) {
    return null;
  }

  const seoTags: MetaInfo = {
    meta: [],
  };

  if (page?.meta_title || page?.title || page?.name) {
    seoTags.title = page?.meta_title || page?.title || page?.name;
  }
  if (page?.meta_description) {
    seoTags.meta.push({
      hid: 'description',
      name: 'description',
      content: page.meta_description,
    });
  }
  if (page?.meta_keyword || page?.meta_keywords) {
    seoTags.meta.push({
      hid: 'keywords',
      name: 'keywords',
      content: page?.meta_keyword || page?.meta_keywords,
    });
  }
  if (isNoIndex) {
    seoTags.meta.push({
      name: 'robots',
      content: 'noindex, nofollow',
    });
  }

  if (page?.pageTitle) {
    seoTags.meta.push({
      hid: 'og:title',
      name: 'og:title',
      property: 'og:title',
      content: page?.pageTitle,
    });
  }
  if (page?.metaDescription) {
    seoTags.meta.push({
      hid: 'og:description',
      name: 'og:description',
      property: 'og:description',
      content: page.metaDescription,
    });
  }
  if (page?.pageUrl) {
    seoTags.meta.push({
      hid: 'og:url',
      name: 'og:url',
      property: 'og:url',
      content: page.pageUrl,
    });
  }
  if (page?.pageImage) {
    seoTags.meta.push({
      hid: 'og:image',
      name: 'og:image',
      property: 'og:image',
      content: page.pageImage,
    });
  }

  return seoTags;
};
